export default "/images/page_not_found.png?a1ff8221228689ca629917786198ac33";